var map = {
  "./cs.json": [
    "dQQ",
    [
      "bs"
    ]
  ],
  "./en.json": [
    "ty",
    [
      "f1p"
    ]
  ],
  "./pl.json": [
    "YnW",
    [
      "6g"
    ]
  ],
  "./ru.json": [
    "xQA",
    [
      "jb"
    ]
  ],
  "./tr.json": [
    "npQ",
    [
      "55e"
    ]
  ],
  "./ja.json": [
    "hdw",
    [
      "ft"
    ]
  ],
  "./zh.json": [
    "fz7",
    [
      "lr"
    ]
  ],
  "./pt-br.json": [
    "A2",
    [
      "q"
    ]
  ],
  "./de.json": [
    "TMN",
    [
      "hv"
    ]
  ],
  "./es.json": [
    "Ssc",
    [
      "4oi"
    ]
  ],
  "./fr.json": [
    "W9",
    [
      "8hh"
    ]
  ],
  "./it.json": [
    "Xw",
    [
      "pgp"
    ]
  ],
  "./ko.json": [
    "qx8",
    [
      "4qp"
    ]
  ],
  "./pt.json": [
    "hl",
    [
      "j0"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "wz";
module.exports = __rspack_async_context;
